import React from 'react';
import Navbar from '@/components/Navbar';
import { Card } from '@/components/ui/card';

export default function TermosDeUso() {
  const updatedAt = '2025-06-19';
  return (
    <div className="min-h-screen bg-muted/30">
      <Navbar />

      {/* Main Content */}
      <main className="container px-4 mx-auto py-12">
        <div className="max-w-3xl mx-auto">
          <div className="mb-8">
            <a href="/" className="text-brand-azul hover:text-brand-roxo transition-colors underline">Voltar</a>
          </div>

          <h1 className="font-display text-3xl md:text-4xl font-extrabold text-brand-azul mb-2">Termos de uso</h1>
          <p className="text-brand-azul/60 mb-6">Última atualização: {updatedAt}</p>

          <Card className="p-8 space-y-6 border-border rounded-2xl">
            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">TERMOS DE USO DA DGENNY COMPRE.AI</h2>
              <p className="text-brand-azul/80">
                Estes Termos de Uso ("Termos") regem a relação entre a DGENNY TECNOLOGIA LTDA ("Empresa" ou "Contratada"), pessoa jurídica de direito privado, inscrita no CNPJ/MF sob o nº 60.232.645/0001-81, com sede na Rua Frei Caneca, 520, G41PAVGA, Florianópolis, Santa Catarina, CEP 88025-053, e o contratante ("Usuário" ou "Contratante") que aderir ao software DGenny Compre.AI ("Serviço" ou "Sistema"), destinado a dar suporte ao processo de compras e otimizar atividades relacionadas em empresas.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">OBJETO DOS TERMOS</h2>
              <p className="text-brand-azul/80">
                Os presentes Termos estabelecem as condições para a utilização do Serviço, que é disponibilizado em quatro planos pagos (Basic, Advanced, Pro e Premium).
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">DEFINIÇÕES</h2>
              <p className="text-brand-azul/80">
                "Serviço" ou "Sistema": o software DGenny Compre.AI, que oferece suporte ao processo de compras por meio de ferramentas de inteligência artificial e funcionalidades específicas descritas nestes Termos.
              </p>
              <p className="text-brand-azul/80">
                "Empresa" ou "Contratada": DGENNY TECNOLOGIA LTDA, responsável pela oferta e manutenção do Serviço.
              </p>
              <p className="text-brand-azul/80">
                "Usuário" ou "Contratante": pessoa física ou jurídica que contrata e utiliza o Serviço.
              </p>
              <p className="text-brand-azul/80">
                "Planos": modalidades de acesso ao Serviço, sendo Basic, Advanced, Pro e Premium.
              </p>
              <p className="text-brand-azul/80">
                "Negociações": cada conversa iniciada pelo Serviço com um fornecedor, contada como uma única negociação, que abrange desde o envio da primeira mensagem até o encerramento definido pela inteligência artificial ou pelo comprador.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">ACEITAÇÃO DOS TERMOS</h2>
              <p className="text-brand-azul/80">
                Ao contratar ou utilizar o Serviço, o Contratante declara ter lido, compreendido e aceitado integralmente estes Termos, bem como quaisquer políticas complementares eventualmente publicadas pela Contratada. A continuidade do uso do Serviço após alterações nestes Termos será considerada como aceitação tácita das mudanças.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">VIGÊNCIA E RESCISÃO</h2>
              <p className="text-brand-azul/80">
                4.1. O presente Termo entrará em vigor na data de liberação do acesso ao Sistema, que ocorrerá: Para os planos pagos (Basic, Advanced, Pro e Premium): após a confirmação do pagamento da primeira parcela.
              </p>
              <p className="text-brand-azul/80">
                4.2. Planos pagos (Basic, Advanced, Pro e Premium): o prazo de vigência deste Termo para estes planos é indeterminado, com renovação automática mensal, condicionada ao pagamento antecipado. Qualquer uma das Partes poderá rescindir o presente instrumento a qualquer momento, sem necessidade de prévio aviso e sem qualquer ônus. Neste caso, o Contratante não terá direito a estorno de valores pagos antecipadamente, permanecendo o Sistema acessível até o final do período contratado.
              </p>
              <p className="text-brand-azul/80">
                4.3. Não haverá multa por rescisão antecipada nos planos pagos, dado que os contratos são mensais e pré-pagos. O cancelamento implicará na perda imediata de acesso ao Sistema ao final do ciclo pago, sem reembolso dos valores já quitados.
              </p>
              <p className="text-brand-azul/80">
                4.4. A reativação da conta poderá ser feita em até 60 (sessenta) dias após o cancelamento, desde que o Contratante esteja adimplente no momento do cancelamento. A reativação estará sujeita a novo pagamento, iniciando um novo ciclo contratual, conforme os preços vigentes à época. Após 60 dias do cancelamento, a conta e seus dados serão permanentemente excluídos, salvo vedação legal ou judicial.
              </p>
              <p className="text-brand-azul/80">
                4.5. O presente Termo poderá ser rescindido a qualquer tempo e independentemente de notificação prévia nas seguintes hipóteses: a) Infração às suas cláusulas e condições; b) Pedido de recuperação judicial ou falência de qualquer das Partes; c) Inadimplência do Contratante por mais de 40 (quarenta) dias, resultando na interrupção definitiva dos serviços.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">DESCRIÇÃO DO SERVIÇO E PLANOS</h2>
              <p className="text-brand-azul/80">
                As características e limitações de cada Plano e Pacote (quantidade de negociações, número de disparos de mensagens iniciais no WhatsApp, quantidade de usuários, etc) estão disponíveis na proposta aprovada pela CONTRATANTE. O CONTRATANTE é responsável pela gestão do seu plano e pacote, e concorda que, em caso de ultrapassar alguma destas características, deverá contratar um plano e/ou pacote proporcional à sua utilização. Os preços e limites podem ser ajustados pela Contratada, com comunicação prévia ao Contratante, respeitando os contratos vigentes.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">CONDIÇÕES DE USO</h2>
              <p className="text-brand-azul/80">
                6.1. Elegibilidade — O Contratante deve ter capacidade jurídica para contratar o Serviço. Caso represente uma pessoa jurídica, declara possuir poderes para vinculá-la a estes Termos.
              </p>
              <p className="text-brand-azul/80">
                6.2. Acesso — O Serviço é acessado por meio de credenciais pessoais (login e senha), sendo o Contratante responsável por sua guarda e uso exclusivo. O Serviço é intransferível, sendo vedada a cessão ou compartilhamento com terceiros.
              </p>
              <p className="text-brand-azul/80">
                6.3. Não Exclusividade — O Serviço é oferecido de forma não exclusiva, podendo a Contratada disponibilizá-lo a outros usuários ou empresas, sem garantia de exclusividade territorial ou setorial.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">OBRIGAÇÕES DO CONTRATANTE</h2>
              <p className="text-brand-azul/80">
                Realizar o pagamento dos valores devidos conforme plano contratado, na forma e prazos estabelecidos. Utilizar o Serviço em conformidade com a legislação vigente e estes Termos. Fornecer informações precisas e atualizadas no cadastro. Não utilizar o Serviço para fins ilícitos ou que violem direitos de terceiros. Responsabilizar-se integralmente pelos atos de usuários autorizados. Proteger a propriedade intelectual da Contratada e comunicar qualquer violação. Manter seu cadastro atualizado junto à Contratada.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">OBRIGAÇÕES DA CONTRATADA</h2>
              <p className="text-brand-azul/80">
                Disponibilizar o Serviço conforme funcionalidades e limites de cada plano contratado. Garantir a disponibilidade do Sistema 24 horas por dia, 7 dias por semana, exceto em casos de manutenção programada ou eventos de força maior. Adotar medidas de segurança técnicas e organizacionais para proteger os dados do Contratante. Informar o Contratante sobre atualizações, interrupções ou mudanças significativas no Serviço com antecedência razoável. Prestar suporte técnico em canais e horários a serem definidos em política específica. Fornecer os dados do Contratante em formato CSV para download, em até 60 dias após o cancelamento.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">PAGAMENTO</h2>
              <p className="text-brand-azul/80">
                O pagamento dos planos é pré-pago, realizado mensalmente ou conforme periodicidade contratada. Pacotes adicionais de negociações também seguem a modalidade pré-paga. A falta de pagamento autoriza a suspensão imediata do acesso ao Serviço, sem prejuízo de outras medidas cabíveis.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">DISPOSIÇÕES FINANCEIRAS</h2>
              <p className="text-brand-azul/80">
                10.1. Em caso de atraso no pagamento, os valores terão a incidência de correção monetária conforme a variação positiva do IPCA/IBGE e juros de 1% ao mês (pro rata die) desde o vencimento até a efetiva quitação, bem como multa moratória de 2%.
              </p>
              <p className="text-brand-azul/80">
                10.2. No caso de atraso no pagamento superior a 40 (quarenta) dias, a Contratada poderá bloquear o uso do Sistema e rescindir o Contrato.
              </p>
              <p className="text-brand-azul/80">
                10.3. É proibido ao Contratante reter pagamentos devidos à Contratada, por qualquer motivo.
              </p>
              <p className="text-brand-azul/80">
                10.4. Os valores descritos são líquidos e deverão ser acrescidos de todos os encargos fiscais e tributários incidentes, que serão arcados pelo Contratante.
              </p>
              <p className="text-brand-azul/80">
                10.5. A criação de novos tributos ou a modificação dos existentes, a alteração de alíquotas, ou novas interpretações pelas autoridades fiscais quanto à arrecadação de tributos serão refletidas de forma automática sobre o valor a ser faturado pela Contratada ao Contratante, mantendo-se o valor líquido contratado.
              </p>
              <p className="text-brand-azul/80">
                10.6. Caso os custos da Contratada se elevem em razão de qualquer mudança de mercado, situação ou medida econômica e/ou alteração legislativa que desvalorize os preços originalmente contratados, as Partes assumem o compromisso de revisar os valores pactuados para manter o equilíbrio econômico e financeiro do Contrato.
              </p>
              <p className="text-brand-azul/80">
                10.7. A Contratada fica autorizada a ceder a terceiros, a seu critério, os direitos creditórios oriundos do Contrato e a realizar a antecipação de eventuais recebíveis junto a instituições financeiras e de crédito, mediante simples comunicação ao Contratante.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">POLÍTICA DE CANCELAMENTO</h2>
              <p className="text-brand-azul/80">
                O Contratante pode cancelar o plano a qualquer momento por meio dos canais oficiais da Contratada. O cancelamento implica a perda imediata de acesso ao Serviço, sem direito a reembolso dos valores já pagos.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">PROPRIEDADE INTELECTUAL</h2>
              <p className="text-brand-azul/80">
                Todos os direitos de propriedade intelectual sobre o Serviço, incluindo software, marcas, designs e conteúdos gerados pela Contratada, pertencem exclusivamente à DGENNY TECNOLOGIA LTDA. O Contratante tem apenas uma licença de uso limitada, não exclusiva e intransferível, restrita ao plano contratado.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">PROTEÇÃO DE DADOS E CONFIDENCIALIDADE</h2>
              <p className="text-brand-azul/80">
                13.1. A Contratada coleta e processa dados do Contratante (ex.: nome, e-mail, dados de negociação) para a prestação do Serviço, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018). O Contratante consente com o uso desses dados para os fins do Serviço, sendo informado sobre eventuais compartilhamentos com terceiros (ex.: fornecedores) quando necessário à execução das negociações.
              </p>
              <p className="text-brand-azul/80">
                13.2. A Contratada adota medidas de segurança como criptografia, controle de acesso e backups para proteger os dados do Contratante contra perda, acesso não autorizado ou uso indevido.
              </p>
              <p className="text-brand-azul/80">
                13.3. Ambas as Partes obrigam-se a manter em sigilo informações sensíveis trocadas durante o uso do Serviço, exceto quando exigido por lei ou consentido previamente.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">LIMITAÇÃO DE RESPONSABILIDADE</h2>
              <p className="text-brand-azul/80">
                A Contratada não se responsabiliza por: Danos indiretos, lucros cessantes ou perdas decorrentes do uso ou indisponibilidade do Serviço. Falhas em negociações conduzidas pelo Contratante ou fornecedores. Interrupções do Serviço por força maior ou eventos fora de seu controle (ex.: falhas de infraestrutura de internet). Danos causados por terceiros ou uso indevido do Sistema. Qualquer responsabilidade da Contratada não ultrapassará o valor pago pelo Contratante nos últimos 12 meses.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">COMPLIANCE</h2>
              <p className="text-brand-azul/80">
                15.1. O Contratante e a Contratada declaram estar cientes e em conformidade com a legislação anticorrupção aplicável, abstendo-se de práticas ilegais como suborno, propina ou pagamentos indevidos a agentes públicos ou privados.
              </p>
              <p className="text-brand-azul/80">
                15.2. O Contratante indenizará a Contratada por perdas decorrentes de descumprimento dessas obrigações.
              </p>
              <p className="text-brand-azul/80">
                15.3. O Contratante deverá fornecer documentos comprobatórios de conformidade quando solicitado pela Contratada.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">DISPOSIÇÕES GERAIS</h2>
              <p className="text-brand-azul/80">
                16.1. Cessão: a Contratante não poderá ceder, sublicenciar, subcontratar, transferir ou dispor de quaisquer direitos e obrigações suas no âmbito deste Termo, salvo no caso de empresas filiais ou do mesmo grupo econômico, mediante comprovação através de apresentação dos documentos comprobatórios. A Contratada poderá ceder este Termo, total ou parcialmente, a qualquer sociedade do mesmo grupo econômico ou a qualquer terceiro que venha a adquirir a propriedade, os ativos, os direitos de propriedade intelectual da DGenny ou que passe a deter o controle societário da Contratada, inclusive em casos de fusão, aquisição, incorporação ou reestruturação societária.
              </p>
              <p className="text-brand-azul/80">
                16.1.1. Em caso de cessão que altere o país cadastrado na conta, o CONTRATANTE concorda com a alteração de moeda para pagamento.
              </p>
              <p className="text-brand-azul/80">
                16.2. Notificações: Serão realizadas por e-mail ou outros meios oficiais, utilizando os dados cadastrados.
              </p>
              <p className="text-brand-azul/80">
                16.3. Alterações: A Contratada poderá alterar este Termo, notificando o Contratante com antecedência de 10 (dez) dias. A ausência de manifestação implicará aceitação tácita.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">LEGISLAÇÃO APLICÁVEL</h2>
              <p className="text-brand-azul/80">
                17.1. O presente Termo será regido pela lei da República Federativa do Brasil.
              </p>
              <p className="text-brand-azul/80">
                17.2. Fica eleito o Foro da Comarca de Florianópolis, Santa Catarina, para dirimir qualquer controvérsia, com renúncia a qualquer outro.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-display font-bold text-brand-azul">CONTRATANTE</h2>
              <p className="text-brand-azul/80">
                Declara-se o presente Termo aceito por parte da Contratante a partir da assinatura do mesmo, sendo sua firma realizada em formato digital. O plano será ativado a partir da confirmação do pagamento.
              </p>
            </section>
          </Card>

          <div className="text-center text-sm text-brand-azul/60 mt-6">
            <p>
              Consulte também nossa{' '}
              <a href="/politica-de-privacidade" className="underline hover:text-brand-azul">Política de Privacidade</a>.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
